import { useField } from 'formik'
import { Trans } from 'react-i18next'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Input from '@mui/material/Input'
import InputLabel from '@mui/material/InputLabel'

type Props = {
  label: string,
  disabled: boolean,
  className: string,
  name: string,
  fullWidth: boolean,
  type?: string,
  inputProps?: any
}

export default function (props: Props) {

  const [field, meta] = useField(props)
  const { error } = meta
  const isError = !!error

  const renderHelperText = () => {
    if (isError) {
        return error
    } else return ' '
  }

  return (
    <FormControl
      fullWidth={props.fullWidth}
      className={props.className}
    >
      <Input
        {...field}
        disabled={props.disabled}
        error={isError}
        inputProps={props.inputProps || {}}
        type={props.type || 'text'}
      />
      <FormHelperText>
          {renderHelperText()}
      </FormHelperText>
      <InputLabel>
        <Trans i18nKey={props.label}></Trans>
      </InputLabel>
    </FormControl>
  )
}